import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import api from '@http/api';
import { Grid, Card } from '@material-ui/core';
import ButtonComponent from '@components/Shared/Buttons/Button';
import { Form, Select,  Input, Spin, Divider, Select as SelectAntd} from 'antd';
import TableCustomKeysNoPagination from '@src/components/Shared/Tables/TableCustomKeysNoPagination';
import Button from '@components/Shared/Buttons/Button';
import { Search} from '@material-ui/icons';


import Services, {
  IGetAllDocumentosTable,
  IGetAllProjetos,
  IGetAllDocumentos,
  IGetAllProjetosDocumentos,
  IAno,
} from './services';

const columnsLabel = {
  id: 'ID',
  descricao: 'Descrição',
};

const Documento: React.FC = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<IGetAllProjetosDocumentos[]>([]);
  const [projetos, setProjetos] = useState<IGetAllProjetos[]>([]);
  const [documentos, setDocumentos] = useState<IGetAllDocumentos[]>([]);
  const [projetoSelected, setProjetoSelected] = useState<any>();
  const [anoSelected, setAnoSelected] = useState<any>(0);
  const [formref] = Form.useForm();
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [habilitarBotao, setHabilitarBotao] = useState(false);
  const { Option } = Select;
  const [ano, setAno] = useState<IAno[]>([
    { id: 2026, descricao: '2026'},
    { id: 2025, descricao: '2025'},
    { id: 2024, descricao: '2024'},
    { id: 2023, descricao: '2023' },
    { id: 2022, descricao: '2022' },
    { id: 2021, descricao: '2021'},
    { id: 2020, descricao: '2020'},
    { id: 2019, descricao: '2019'},
    { id: 2018, descricao: '2018'},
  ]);

  async function loadGetDocumentoByProjetoAno() {
    setLoading(true);

    if (anoSelected === 0){
      await api
      .get( `/api/DocumentacaoProjetoIr/GetByProjetoAno?projetoId=${projetoSelected}`)

      .then(response => {
        const items = response.data;
        const itemData: IGetAllProjetosDocumentos[] = items.map((item: IGetAllProjetosDocumentos) => ({
          id: item.documento.id,
          descricao: item.documento.descricao,
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar(`Ocorreu um erro`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });

    } else if (anoSelected !== 0 )
    {
    await api
      .get( `/api/DocumentacaoProjetoIr/GetByProjetoAno?projetoId=${projetoSelected}&&ano=${anoSelected}`)

      .then(response => {
        const items = response.data;
        const itemData: IGetAllProjetosDocumentos[] = items.map((item: IGetAllProjetosDocumentos) => ({
          id: item.documento.id,
          descricao: item.documento.descricao,
        }));

        setData(itemData);
        setLoading(false);
      })
      .catch(error => {
        enqueueSnackbar(`Ocorreu um erro`, {
          variant: 'error',
          anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
        });
      });
    }
  }




  async function loadGetAllDocumentos() {
    setLoading(true);

    const service = new Services();
    const { error, response } = await service.GetAllDocumentos();
    setDocumentos(response);

    setLoading(false);
  }

  async function loadGetAllProjetos() {
    setLoading(true);

    const service = new Services();
    const { error, response } = await service.GetAllProjetos();
    setProjetos(response);

    setLoading(false);
  }

 async function onSubmit(values: any) {
    setLoadingCreate(true);

    const createDocumento = {
      ano: values.ano,
      projetoId: values.projeto,
      documentoIds: values.selectDocumento,
    };

    const service = new Services();
    const { error } = await service.CreateDocumento(createDocumento);

    setLoadingCreate(false);

    if (!error) {
      enqueueSnackbar(`Cadastro finalizado com sucesso!`, {
        variant: 'success',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });

      clear();
      setHabilitarBotao(false);

      loadGetAllDocumentos();

    } else {
      enqueueSnackbar(`Ocorreu um erro`, {
        variant: 'error',
        anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  const clear = () => {
    clearDados();
    clearDocumento()
  }

  const clearDados = () => {
    formref.setFieldsValue({
      ano: '',
    });
    formref.setFieldsValue({
      projeto: '',
    });

  };

  const getAllDocumento = () => {
    const ids: any = [];

    documentos.map(item => ids.push(item.id));

    formref.setFieldsValue({
      selectDocumento: ids,
    });
  };

  const clearDocumento = () => {
    formref.setFieldsValue({
      selectDocumento: [],
    });
  };


  useEffect(() => {
    loadGetAllDocumentos();
    loadGetAllProjetos();
    window.document.title = 'CRM - Formas contribuições';
  }, []);

  return (
    <Grid container>
      <Grid
        container
        item
        sm={12}
        //justify="space-around"
        xs={12}
        lg={12}
        style={{ marginTop: 20 }}
      >
        {/* FORMULARIO  */}
        <Grid item lg={12} sm={12} xs={12}>
          <Spin
            size="large"
            spinning={loadingCreate}
            tip="Enviando dados..."
          >
            <Form
              form={formref}
              size="middle"
              layout="vertical"
              scrollToFirstError={true}
              onFinish={onSubmit}
              labelAlign="left"
              labelCol={{
                span: 24,
              }}
              wrapperCol={{
                span: 24,
              }}
              requiredMark={false}
              initialValues={{
                selectDocumento: [],

              }}
            >

              <Grid container item lg={12} sm={12} xs={12} style={{ paddingTop: 10 }}>

                {/* Lista dos documentos cadastrados  */}
                <Grid container item lg={6} sm={6} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 550,  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>
                  <Grid container
                      item
                      md={12}
                      lg={12}
                      xs={12}
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                    >

                      <Grid
                        item
                        md={5}
                        lg={5}
                        xs={12}
                        style={{
                          paddingRight: 5,
                          paddingLeft: 5,
                          //alignSelf: 'flex-end',
                          paddingTop: 10,
                        }}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}
                          placeholder="Projeto"
                          onChange={(e: any) => {setProjetoSelected(e);}}

                        >
                          {projetos.map(item => (
                            <SelectAntd.Option key={item.id} value={item.id}>
                              {item.nome}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>

                      </Grid>

                      <Grid
                        item
                        md={3}
                        lg={3}
                        xs={12}
                        style={{
                          paddingRight: 5,
                          paddingLeft: 5,
                          //alignSelf: 'flex-end',
                          paddingTop: 10,
                        }}
                      >
                        <SelectAntd
                          style={{ width: '100%' }}
                          placeholder="Ano"
                          onChange={(e: any) => {setAnoSelected(e);}}
                        >
                          {ano.map(item => (
                            <SelectAntd.Option key={item.id} value={item.id}>
                              {item.descricao}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>

                      </Grid>

                      <Grid
                        item
                        md={2}
                        lg={2}
                        xs={12}
                        style={{
                          paddingRight: 5,
                          paddingLeft: 5,
                          //alignSelf: 'flex-end',
                          paddingTop: 10,
                        }}
                      >
                        <Button
                          color="secondary"
                          fullWidth
                          style={{
                            height: 32,
                          }}
                          onClick={loadGetDocumentoByProjetoAno}
                        >
                          <Search />
                        </Button>
                      </Grid>
                    </Grid>

                    <Grid
                      item
                      lg={12}
                      xs={12}
                      style={{ paddingRight: 2, paddingLeft: 2, paddingTop: 5 }}
                    >

                      <TableCustomKeysNoPagination
                        loading={loading}
                        columns={[columnsLabel]}
                        FieldsBold={['descricao']}
                        data={data}
                        keys={[
                          'id',
                          'descricao',
                        ]}
                      />
                    </Grid>
                  </Card>
                </Grid>

                {/* Novo cadastro de documentos  */}
                <Grid container item lg={5} sm={5} xs={12} style={{ padding: 0 }}>
                  <Card style={{ padding: 20, borderRadius: 8, width: 450, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                    <Grid item lg={10} md={10} xs={10} style={{ paddingLeft: 150, paddingRight: 5, alignSelf: 'end' }}>
                      <ButtonComponent
                        fullWidth
                        style={{ height: 50, borderRadius: 5,}}
                        color={"secondary"}
                        onClick={() => {
                          setHabilitarBotao(true)
                        }}
                      >
                        Vincular documento(s) com projeto
                      </ButtonComponent>
                    </Grid>

                    <Grid container>
                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="projeto" label="Projeto"
                          rules={[
                            {
                              required: true,
                              message: 'Selecione um Projeto',
                            },
                          ]}
                        >
                          <SelectAntd
                            style={{ width: '100%' }}
                            disabled={habilitarBotao !== true}
                          >
                            {projetos.map(item => (
                              <SelectAntd.Option key={item.id} value={item.id}>
                                {item.nome}
                              </SelectAntd.Option>
                            ))}
                          </SelectAntd>
                        </Form.Item>
                      </Grid>

                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item
                          name="selectDocumento"
                          label="Documentos"
                          rules={[
                            {
                              type: 'array',
                            },
                          ]}
                        >
                          <Select
                            //placeholder="Cadastro"
                            mode="multiple"
                            showSearch={false}
                            dropdownRender={menu => (
                              <div>
                                {menu}
                                <Divider style={{ margin: '10px 0' }} />
                                <div
                                  style={{
                                    display: 'flex',
                                    flexWrap: 'nowrap',
                                    flexDirection: 'row',
                                    padding: 10,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: '50%',
                                      justifySelf: 'center',
                                      alignSelf: 'center',
                                      textAlign: 'center',
                                    }}
                                  >
                                    <a
                                      style={{
                                        flex: 'none',
                                        padding: '4px',
                                        display: 'block',
                                        cursor: 'pointer',
                                        textDecoration: 'None',
                                      }}
                                      onClick={getAllDocumento}
                                    >
                                      Selecionar todos
                                    </a>
                                  </div>
                                  <div
                                    style={{
                                      width: '50%',
                                      justifySelf: 'center',
                                      alignSelf: 'center',
                                      textAlign: 'center',
                                    }}
                                  >
                                    <a
                                      style={{
                                        flex: 'none',
                                        padding: '4px',
                                        display: 'block',
                                        cursor: 'pointer',
                                        textDecoration: 'None',
                                      }}
                                      onClick={clearDocumento}
                                    >
                                    Remover todos
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          >
                            {documentos.map(item => (
                              <Option key={item.id} value={item.id}>
                                {item.descricao}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Grid>

                      <Grid item lg={12} xs={12} style={{ paddingLeft: 10, paddingRight: 10 }}>
                        <Form.Item name="ano" label="Ano"
                          rules={[
                            {
                              required: true,
                              message: 'Adicione um ano',
                            },
                          ]}
                        >
                          <SelectAntd
                          style={{ width: '100%' }}
                          placeholder="Ano"
                          //onChange={(e: any) => {setAnoSelected(e);}}
                        >
                          {ano.map(item => (
                            <SelectAntd.Option key={item.descricao} value={item.descricao}>
                              {item.descricao}
                            </SelectAntd.Option>
                          ))}
                        </SelectAntd>
                        </Form.Item>
                      </Grid>
                    </Grid>

                    <Grid
                      container
                      justify="center"
                      alignItems="center"
                      item
                      lg={12}
                      md={12}
                      xs={12}
                    >
                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="default"
                          fullWidth
                          disabled={habilitarBotao !== true}
                          onClick={clear}
                        >
                          Cancelar
                        </ButtonComponent>
                      </Grid>

                      <Grid item lg={4} md={4} xs={12} style={{ paddingTop: 10, paddingLeft: 5, paddingRight: 5 }}>
                        <ButtonComponent
                          color="primary"
                          fullWidth
                          type="submit"
                          disabled={habilitarBotao !== true}
                        >
                          Salvar
                        </ButtonComponent>
                      </Grid>
                    </Grid>
                  </Card>
                </Grid>
              </Grid>
            </Form>
          </Spin>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Documento;
